export enum AccountingDocumentsViewOption {
  Open = 'open',
  Closed = 'closed',
}
